<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-row>
        <el-col :md="6" style="margin-bottom: 15px">
          <!-- 数据表格 -->
          <ele-data-table
            ref="classTable"
            :config="classTable"
            :current.sync="current"
            @done="classTableDone"
            highlight-current-row
            :height="tbHeight"
            class="dict-table"
          >
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="name" label="班级" show-overflow-tooltip />
          </ele-data-table>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px">
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="addItem" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">新增项目</el-button>
            <el-button @click="remove()" type="danger" icon="el-icon-setting" class="ele-btn-icon" size="small">批量删除</el-button>
          </div>
          <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
            <template>
              <el-table-column type="selection" width="45" align="center" />
              <el-table-column prop="projectName" label="考核项目" show-overflow-tooltip align="center" />
              <el-table-column label="操作" align="center">
                <template #default="{ row }">
                  <el-link @click="editItem(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
                  <el-popconfirm title="确定要删除此项目？" @onConfirm="remove(row)" class="ele-action">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
    <!--添加修改考核项目-->
    <el-dialog
      :title="editForm.id ? '修改' : '添加'"
      :visible.sync="showEdit"
      width="450px"
      @closed="resetItemForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="项目名称:" prop="projectName">
          <el-input v-model="editForm.projectName" placeholder="请输入项目名称" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveItem">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { delAccessProject, saveAccessProject } from '@/config/yizhongDong/examine';

  export default {
    name: 'classProject',
    data() {
      return {
        table: {
          // 表格配置
          url: '/yzdAccess/classAccessProjectPage',
          method: 'GET',
          where: {
            classId: null,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        editForm: {
          type: 1,
          projectName: null,
        },
        editRules: {
          projectName: [{ required: true, message: '请输入提示语', trigger: 'blur' }],
        },
        showEdit: false,
        classList: [],
        current: null, // 表格选中数据
        classTable: {
          //班级列表
          url: '/yzdAccess/getClassList',
          page: false,
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
      };
    },
    computed: {
      /* 表格固定高度 */
      tbHeight() {
        return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
      },
    },
    watch: {
      'current.id': {
        handler(newValue, oldValue) {
          this.table.where.classId = newValue;
          this.editForm.classId = newValue;
          this.$refs.table.reload();
        },
      },
    },
    methods: {
      /* 表格渲染完成回调 */
      classTableDone(res) {
        this.classList = res.data;
        if (res.data.length > 0) this.$refs.classTable.setCurrentRow(res.data[0]);
      },
      // 添加考核项目
      addItem() {
        this.showEdit = true;
      },
      // 编辑考核项目
      editItem(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存考核项目
      saveItem() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveAccessProject(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除项目
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的项目吗?', '提示', { type: 'warning' }).then(() => {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            formData.append('ids', ids);
            delAccessProject(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          });
        } else {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('ids', [row.id]);
          delAccessProject(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      // 重置表单
      resetItemForm() {
        this.editForm = {
          type: 1,
          projectName: null,
          classId: this.current.id,
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style>
  .custom-row-class {
    height: 50px !important;
  }
</style>
